<template>
  <Popover :trigger="trigger" :delay="delay">
    <template #default>
      <div class="customfields-helper-popover">
        <div class="customfields-helper-popover__content">
          <span class="customfields-helper-popover__title" v-if="content.title">
            <slot name="title">
              {{ content.title }}
            </slot>
          </span>
          <span class="customfields-helper-popover__description" v-if="content.body">
            <slot name="body">
              <span v-html="content.body"></span>
            </slot>
          </span>
          <img
            class="customfields-helper-popover__image"
            :src="content.image"
            v-if="content.image"
          />
          <a
            v-if="content.link"
            class="customfields-helper-popover__link"
            :href="content.link"
            target="_blank"
            :rel="content.title"
          >
            {{ $t('readMore') }}
          </a>
        </div>
      </div>
    </template>
  </Popover>
</template>

<script>
import Popover from './Component.vue'

const fieldGetter = function (key) {
  return function () {
    return this[key] || this.templateComp[key] || Boolean(this.$slots[key])
  }
}

export default {
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
    body: String,
    link: String,
    image: String,
    template: String,
    trigger: {
      type: String,
      default: 'click',
    },
    delay: [String, Number],
  },
  computed: {
    templateComp() {
      return {}
    },
  },

  components: {
    Popover,
  },
}
</script>

<style lang="scss">
.customfields-helper-popover {
  --padding: 1.5rem;

  overflow: hidden;
  max-width: 40ch;

  img {
    height: auto;
    max-width: 100%;
    margin-top: 1rem;
    background-color: rgba(white, 0.1);
  }

  &__content {
    padding: var(--padding);
    display: flex;
    flex-direction: column;
    gap: 0.5em;
  }

  &__title {
    font-weight: bold;
  }

  &__link {
    font-size: 0.9em;
    color: inherit;
    opacity: 0.75;
  }
  a {
    color: inherit;
  }

  &__description {
    line-height: 1.5;
    font-size: 0.9em;
  }

  &__list {
    margin: 0;
    padding: 0;

    &-item {
      list-style: none;
      padding-top: 0.7rem;

      &__label {
      }

      &__sublabel {
        opacity: 0.7;
        display: block;
      }
    }
  }
}
</style>
